import { providesList } from '@helpers/providerList';
import BaseService from '../base';
import { VehiclesApiProps, VehicleParams } from './types';

class Vehicle extends BaseService {
  update() {
    return {
      query: ({ id, ...params }: VehicleParams) => ({
        url: `/vehicles/${id}`,
        method: 'PATCH',
        body: params,
      }),
      invalidatesTags: [{ type: this.tagType, id: 'LIST' }, { type: 'Job' }],
    };
  }

  getVehicles() {
    return {
      query: ({ id, ...params }: VehicleParams) => ({
        url: `/section/${id}/vehicles`,
        params,
      }),
      providesTags: (result?: VehiclesApiProps) => providesList(
        result?.section_vehicles,
        this.tagType,
      ),
    };
  }

  addVehicle() {
    return {
      query: ({ id, ...params }: VehicleParams) => ({
        url: `/section/${id}/vehicles`,
        method: 'POST',
        body: params,
      }),
      invalidatesTags: [{ type: this.tagType, id: 'LIST' }, { type: this.tagType }],
    };
  }
}

export default new Vehicle('vehicles', 'Vehicle');
